import { Button, SnackbarContent } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import React from "react";

import "./CookieConsent.css";

interface CookieConsentProps {
    children: React.ReactNode;
}

const CookieConsent = (props: CookieConsentProps) => {
    const [showCookieConsent, setShowCookieConsent] = React.useState(!isAlreadyAccepted());

    function getCookie(name: string) {
        const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    function isAlreadyAccepted(): boolean {
        const cookie = getCookie("cookieConsent");
        return Boolean(cookie);
    }

    function onAccepted() {
        document.cookie = "cookieConsent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
        setShowCookieConsent(false);
    }

    return (
        <>
            {props.children}
            <Snackbar open={showCookieConsent} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                <SnackbarContent
                    message="This website uses cookies. Only essential information for the operating of the application is collected, and it is not shared with any third-parties outside the Council."
                    action={[
                        <Button key="accept" variant="contained" color="primary" size="small" onClick={onAccepted}>
                            Accept
                        </Button>,
                    ]}
                />
            </Snackbar>
        </>
    );
};

export default CookieConsent;
